'use client';
const placementMap = {
  start: { ltr: "left", rtl: "right" },
  end: { ltr: "right", rtl: "left" }
};
function getDrawerPlacement(placement, dir) {
  if (!placement) {
    return;
  }
  if (placement === "start" || placement === "end") {
    return placementMap[placement]?.[dir];
  }
  return placement;
}

export { getDrawerPlacement };
